<template>
  <img :src="`/images/logo/vigiacte-logo.png`" class="w-56" alt="logo VigiActe">
</template>
